import { environment } from '@environments/environment';

export const GET_SINK_TAP_PACKS_FILTER_QUERY = (langcode: string) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_packs ?? '',
  body: {
    size: 0,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
          {
            term: {
              pack_type: 'Eviers et mitigeurs',
            },
          },
        ],
      },
    },
    aggs: {
      filtres_uniques: {
        terms: {
          field: 'filters',
          size: 100,
        },
      },
    },
  },
});
